import { InternalActionKeyId } from '@libs/define/internal_action_key_id'

type VK = number

const createFnStandardKeyMap = (entries: Array<[number, VK]>) => new Map<number, VK>(entries)

const jingtaiV1FnStandardKeyMap = createFnStandardKeyMap([
  [0x10b5, 0xb0 as VK],
  [0x10b6, 0xb1 as VK],
  [0x10b7, 0xb2 as VK],
  [0x10cd, 0xb3 as VK],
  [0x10e2, 0xad as VK],
  [0x10e9, 0xaf as VK],
  [0x10ea, 0xae as VK],
  [0x1183, 0xb5 as VK],
  [0x118a, 0xb4 as VK],
  [0x1192, 0xb7 as VK],
  [0x1194, 0xb6 as VK],
  [0x1221, 0xaa as VK],
  [0x1223, 0xac as VK],
  [0x1224, 0xa6 as VK],
  [0x1225, 0xa7 as VK],
  [0x1226, 0xa9 as VK],
  [0x1227, 0xa8 as VK],
])

const jingtaiV1ActionKeyByRawCode = new Map<number, InternalActionKeyId>([
  [0xf001, InternalActionKeyId.deviceFn1],
  // [0xf002, InternalActionKeyId.deviceFn2],
  // [0xf003, InternalActionKeyId.deviceFn3],
  [0xf100, InternalActionKeyId.deviceRestore],
  [0xf101, InternalActionKeyId.deviceSwitchToWindowsMode],
  [0xf102, InternalActionKeyId.deviceSwitchToMacMode],
  [0xf108, InternalActionKeyId.deviceSwitchToProfile1],
  [0xf109, InternalActionKeyId.deviceSwitchToProfile2],
  [0xf10a, InternalActionKeyId.deviceSwitchToProfile3],
  [0xf10c, InternalActionKeyId.deviceSwitchToProfile4],
  [0xf309, InternalActionKeyId.deviceWinKeyLock],
  [0xf310, InternalActionKeyId.deviceLightEffectMode],
  [0xf311, InternalActionKeyId.deviceLightDirection],
  [0xf312, InternalActionKeyId.deviceLightBrightnessUp],
  [0xf313, InternalActionKeyId.deviceLightBrightnessDown],
  [0xf314, InternalActionKeyId.deviceLightSpeedUp],
  [0xf315, InternalActionKeyId.deviceLightSpeedDown],
  [0xf317, InternalActionKeyId.deviceLightToggle],
  [0xf339, InternalActionKeyId.deviceSnapTapToggle],
  [0xf108, InternalActionKeyId.deviceSwitchToProfile1],
  [0xf109, InternalActionKeyId.deviceSwitchToProfile2],
  [0xf10a, InternalActionKeyId.deviceSwitchToProfile3],
  [0xf10c, InternalActionKeyId.deviceSwitchToProfile4],
])

const jingtaiV1RawCodeByActionKey = new Map<number, number>(Array.from(jingtaiV1ActionKeyByRawCode.entries()).map(([rawCode, actionKey]) => [actionKey, rawCode]))

export const getJingtaiV1FnStandardKeyMap = (): ReadonlyMap<number, VK> => {
  return jingtaiV1FnStandardKeyMap
}

export const getJingtaiV1ActionKeyByRawCode = (rawCode: number): InternalActionKeyId | undefined => {
  return jingtaiV1ActionKeyByRawCode.get(rawCode)
}

export const getJingtaiV1RawCodeByActionKey = (id: number): number | undefined => {
  return jingtaiV1RawCodeByActionKey.get(id)
}
